import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {getCookie, removeCookie, setCookie} from "../../utils/cookie"

export interface StateProps {
    token: string | null
}

const initialState: StateProps = {
    token: getCookie("mystery_shopper_crm_token_access") || null
}

const authSlice = createSlice({
    name: "auth",
    initialState: initialState,
    reducers: {
        // Изменить токен
        updateToken: (state, action: PayloadAction<{token: string | null; expires: number}>) => {
            const {token, expires} = action.payload
            if (token) setCookie("mystery_shopper_crm_token_access", token, {expires: expires || 30})
            else removeCookie("mystery_shopper_crm_token_access")
            state.token = token
        }
    }
})

export default authSlice.reducer
// Обновить токен
export const {updateToken} = authSlice.actions
